import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { TAGLINES } from "../../lib/memeData";

export const TaglineRotator = () => {
  const [i, setI] = useState(0);

  useEffect(() => {
    const t = setInterval(() => {
      setI((prev) => (prev + 1) % TAGLINES.length);
    }, 1600);
    return () => clearInterval(t);
  }, []);

  return (
    <section
      className="px-5 md:px-10 py-10 md:py-14"
      data-testid="tagline-rotator-section"
    >
      <div className="max-w-5xl mx-auto crayon-card relative px-6 md:px-10 py-10 md:py-14 text-center -rotate-1">
        <span className="tape" />
        <p className="font-display text-2xl md:text-3xl text-[#E8742C] mb-3">
          our official mission statement (live updating, getting shorter)
        </p>
        <div className="min-h-[100px] md:min-h-[140px] flex items-center justify-center">
          <AnimatePresence mode="wait">
            <motion.h2
              key={i}
              initial={{ opacity: 0, y: 30, rotate: -3 }}
              animate={{ opacity: 1, y: 0, rotate: 0 }}
              exit={{ opacity: 0, y: -30, rotate: 3 }}
              transition={{ duration: 0.4 }}
              className="font-display text-4xl sm:text-5xl md:text-7xl text-[#1A1A1A]"
              data-testid="tagline-text"
            >
              {TAGLINES[i]}
            </motion.h2>
          </AnimatePresence>
        </div>
        <div className="mt-4 flex items-center justify-center gap-1.5">
          {TAGLINES.map((_, idx) => (
            <span
              key={idx}
              className={`h-2.5 rounded-full border-2 border-[#1A1A1A] transition-all ${
                idx === i ? "w-8 bg-[#E8742C]" : "w-2.5 bg-white"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TaglineRotator;
